export enum EWizardType {
  Autoship = 'Autoship',
  Subscription = 'Subscription',
}
